import {FontSizes, hs, isPhone, vs} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: vs(16),
    paddingTop: vs(20),
  },
  header: {
    fontSize: FontSizes[20],
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#4D3F37',
  },
  section: {
    marginVertical: vs(16),
    paddingHorizontal: vs(12),
  },
  sectionHeader: {
    fontSize: FontSizes[16],
    fontWeight: 'bold',
    color: '#4D3F37',
    marginBottom: vs(8),
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  input: {
    flex: 1,
    marginHorizontal: vs(8),
    marginVertical: vs(8),
    minWidth: vs(140),
  },
  avatarGrid: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: vs(12),
  },
  avatarPreview: {
    alignItems: 'center',
    marginTop: vs(12),
  },
  avatarName: {
    fontSize: FontSizes[14],
    fontWeight: 'bold',
    marginVertical: vs(4),
  },
  avatarTagline: {
    fontSize: FontSizes[12],
    color: '#6D6D6D',
    textAlign: 'center',
  },
  errorText: {
    color: 'red',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  successText: {
    color: 'green',
    textAlign: 'center',
    marginVertical: vs(8),
  },
  buttonContainer: {
    alignItems: 'center',
    marginVertical: vs(16),
  },
  saveButton: {
    backgroundColor: '#FACF47',
    borderRadius: vs(24),
    paddingVertical: vs(12),
    paddingHorizontal: vs(48),
  },
  item: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    margin: vs(4),
    padding: vs(8),
    backgroundColor: '#FAF6EB',
    borderRadius: vs(8),
  },
  itemInvisible: {
    backgroundColor: 'transparent',
  },
  itemText: {
    fontSize: FontSizes[12],
    textAlign: 'center',
  },
  // Tab related styles
  tabContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: vs(16),
  },
  tabButton: {
    marginHorizontal: vs(6),
    minWidth: vs(160),
  },
  tabContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabs: {
    width: isPhone ? '100%' : '30%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  tab: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderBottomColor: '#FFC107',
  },
  tabText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
  },
});
